/**
 * @file 中文语言包
 * @description 中文翻译内容
 */

export default {
  common: {
    welcome: '欢迎您',
  },
}
